export enum LotCheckStatus {
    Selected,
    UnSelected,
    PartiallySelected
}